import { render, staticRenderFns } from "./VatPreviewSection.vue?vue&type=template&id=30333963&scoped=true"
import script from "./VatPreviewSection.vue?vue&type=script&lang=js"
export * from "./VatPreviewSection.vue?vue&type=script&lang=js"
import style0 from "./VatPreviewSection.vue?vue&type=style&index=0&id=30333963&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30333963",
  null
  
)

export default component.exports